var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderBreadcrumbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 326,
    height: 30,
    viewBox: "0 0 326 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324.75,
    height: 29.25,
    x: 0.375,
    y: 0.375,
    stroke: "#D9D9D9",
    strokeWidth: 0.75,
    rx: 3.75
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 12
  }, "Fastball")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68.25,
    y: 12
  }, "In Play")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 126.75,
    y: 12
  }, "Ground Ball")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 202.5,
    y: 12
  }, "Single")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 253.5,
    y: 12
  }, "G-6")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9,
    y: 24
  }, "1 Outs on play")), /*#__PURE__*/React.createElement("text", {
    fill: "#D9D9D9",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 9,
    fontWeight: "bold",
    letterSpacing: 0.346
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 90.75,
    y: 24
  }, "How many runs was scored?")), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    d: "M52.873 13.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221zM79.873 25.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221zM111.373 13.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221zM188.623 13.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221zM241.123 13.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221zM278.623 13.5a.751.751 0 0 1-.53-1.28l3.222-3.222-3.222-3.222a.75.75 0 0 1 0-1.058.751.751 0 0 1 1.06 0l3.754 3.751a.75.75 0 0 1 0 1.058l-3.755 3.752c-.14.14-.33.22-.53.221z",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBreadcrumbs);
export default __webpack_public_path__ + "static/media/placeholder-breadcrumbs.b00d9cda00f52c2ad74730bebaf685ec.svg";
export { ForwardRef as ReactComponent };